/* eslint-disable @typescript-eslint/naming-convention */
import { Image } from '@udemy/react-core-components';
import classNames from 'classnames';
import React from 'react';
import { EXPRESSIVE_ICON_FILE_PATHS } from '../asset-links';
import styles from "./expressive-icon.module.css";
const iconFileWidth = 200;
const iconFileHeight = 200;
/** React prop interface for the `ExpressiveIcon` component */

/**
 *
 * @param cdnUrlBase - a string that is the base url for the CDN
 * @param name - the key of the ExpressiveIcon you want to render. @see {@link ExpressiveIconName}
 * @param colorCheme - the color scheme of the icon to render. @see {@link ExpressiveIconProps}
 * @returns string of the srcSet to pass to the `Image` @see {@link Image} component
 */
export const getExpressiveIconSrcSet = function (name) {
  let cdnEnv = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'prod';
  let colorScheme = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'light';
  return `${EXPRESSIVE_ICON_FILE_PATHS[cdnEnv]}${colorScheme}/1x/${name}.webp 1x, ${EXPRESSIVE_ICON_FILE_PATHS[cdnEnv]}${colorScheme}/2x/${name}.webp 2x`;
};
/**
 * ### ExpressiveIcon
 *
 * @remarks
 * Branded images that are in a space between vector icons and illustrations.
 *
 * Renders an {@link Image Image} component with a `srcSet` attribute set up
 * to pull in 1x and 2x images from the CDN.
 */

export const ExpressiveIcon = _ref => {
  let {
    name,
    colorScheme = 'light',
    size = 'medium',
    cdnEnv = 'prod',
    className,
    ...props
  } = _ref;
  const pictureSources = getExpressiveIconSrcSet(name, cdnEnv, colorScheme);
  return /*#__PURE__*/React.createElement(Image, Object.assign({
    alt: "",
    "aria-hidden": true,
    srcSet: pictureSources,
    className: classNames(styles[size], className),
    width: iconFileWidth,
    height: iconFileHeight
  }, props));
};
//# sourceMappingURL=expressive-icon.react-component.js.map